import React from 'react';
import { FileCheck, Users, Leaf, BadgeCheck, Clock, Shield } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const WhyUsSection = () => {
  const navigate = useNavigate();
  const reasons = [
    {
      icon: FileCheck,
      title: 'Transparente Festpreise',
      description: 'Keine versteckten Kosten, keine bösen Überraschungen. Sie erhalten klare Angebote mit detaillierten Leistungsbeschreibungen und verbindlichen Preisen.'
    },
    {
      icon: Users,
      title: 'Feste Teams & Ansprechpartner',
      description: 'Persönliche Betreuung durch feste Teams und einen direkten Ansprechpartner. So entsteht Vertrauen und gleichbleibende Qualität.'
    },
    {
      icon: Shield,
      title: 'Vollständig versichert & geprüft',
      description: 'Umfassende Betriebshaftpflichtversicherung, geschulte Mitarbeiter und dokumentierte Prozesse für Ihre Sicherheit und Ihr Vertrauen.'
    },
    {
      icon: Leaf,
      title: 'Nachhaltige Reinigungsmittel',
      description: 'Umweltschonende Produkte und ressourcenschonende Verfahren. Gesund für alle Nutzer, gut für die Umwelt und schonend für Ihre Räumlichkeiten.'
    },
    {
      icon: BadgeCheck,
      title: 'Zufriedenheitsgarantie',
      description: 'Sollte einmal etwas nicht Ihren Erwartungen entsprechen, reinigen wir kostenfrei nach. Ihre Zufriedenheit ist unser Qualitätsmaßstab.'
    },
    {
      icon: Clock,
      title: 'Flexibel & zuverlässig',
      description: 'Reinigung außerhalb Ihrer Geschäftszeiten, flexible Intervalle und schnelle Reaktionszeiten bei Sonderwünschen oder Notfällen.'
    }
  ];

  return (
    <section id="why-us" className="py-16 sm:py-20 lg:py-24 bg-[#0A2846] text-[#E8EEF3] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-96 h-96 bg-[#D4AF37] rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#FFD700] rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12 sm:mb-16 fade-in">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 px-2">
            Warum PROBAV wählen?
          </h2>
          <div 
            className="w-24 sm:w-32 h-1.5 mx-auto mb-6 sm:mb-8 rounded-full"
            style={{ 
              background: 'linear-gradient(90deg, #D4AF37 0%, #FFD700 50%, #F4D03F 100%)',
              boxShadow: '0 4px 15px rgba(212, 175, 55, 0.6)'
            }} 
          />
          <p className="text-lg sm:text-xl text-[#E8EEF3]/90 max-w-3xl mx-auto leading-relaxed px-4">
            Professionelle Gebäudereinigung bedeutet mehr als nur Sauberkeit – es geht um Werterhaltung, Zufriedenheit und verlässliche Partnerschaften
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm p-8 rounded-xl border-2 hover:border-[#D4AF37] transition-all duration-300 hover:scale-105"
                style={{ 
                  borderColor: 'rgba(212, 175, 55, 0.2)',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
                }}
              >
                <div 
                  className="w-16 h-16 rounded-full flex items-center justify-center mb-5"
                  style={{
                    background: 'linear-gradient(135deg, #D4AF37 0%, #FFD700 100%)',
                    boxShadow: '0 8px 20px rgba(212, 175, 55, 0.4)'
                  }}
                >
                  <Icon className="w-8 h-8 text-[#0A2846]" />
                </div>
                <h3 className="text-2xl font-semibold mb-3">{reason.title}</h3>
                <p className="text-[#E8EEF3]/80 leading-relaxed">{reason.description}</p>
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <Button
            onClick={() => navigate('/kontakt')}
            className="font-semibold text-lg px-10 py-6 transition-all duration-300 hover:scale-105"
            style={{
              background: 'linear-gradient(135deg, #D4AF37 0%, #FFD700 50%, #F4D03F 100%)',
              color: '#0A2846',
              boxShadow: '0 8px 30px rgba(212, 175, 55, 0.5), 0 0 40px rgba(212, 175, 55, 0.3)'
            }}
          >
            Jetzt Erstgespräch vereinbaren
          </Button>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;